<template>
  <!--=== slides ============================-->
  <section class="banner_area">
    <div v-if="slider.length" class="intro-container">
      <div v-for="(slide, index) in slider" :key="index" id="introCarousel"
        :class="['carousel', 'slide', 'carousel-fade', { active: index === currentIndex }]">
        <div class="carousel-inner">
          <div :class="['carousel-item', { active: index === currentIndex }]">
            <div class="carousel-background">
              <div class="bg-parallax overlay"
                :style="{ backgroundImage: 'url(' + $imgURL + slide.insInstitucionalImagens[0].itgUrlImagem + ')' }">
              </div>
            </div>

            <div class="carousel-container">
              <div class="carousel-content banner_content text-center">
                <h2 class="banner__titulo">{{ slide.itiNome }}</h2>
                <h4 class="banner__subtitulo">{{ slide.itiReferencia }}</h4>
                <p>
                  <router-link class="btn theme_btn button_hover banner__botao" :to="slide.itiLinkBtn1">
                    {{ slide.itiTextoBtn1 }}
                  </router-link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';

export default {
  name: "PageSlider",
  data() {
    return {
      slider: [],
      slide: [],
      currentIndex: 0,
      interval: null,
    };
  },
  mounted() {
    this.fetchSlides();
    this.startSlider();
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  methods: {
    startSlider() {
      this.interval = setInterval(() => {
        this.nextSlide();
      }, 7000);
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.slider.length;
    },
    goToSlide(index) {
      clearInterval(this.interval);
      this.currentIndex = index;
      this.startSlider();
    },
    async fetchSlides() {
      try {
        const response = await axios.get('/Process/InsInstitucional/institucional/34/slides/0/x');
        this.slider = response.data
          .filter(x => x.itiVisivel) // se quiser mostrar apenas os visíveis
          .sort((a, b) => (parseInt(a.itiOrdem) || 0) - (parseInt(b.itiOrdem) || 0));
      } catch (error) {
        console.error(error);
      }
      //console.log('slider')
      //console.log(this.slider)
    }
  }
};
</script>

<style scoped>
/* ======== Área principal ======== */
.banner_area {
  position: relative;
  width: 100%;
  height: 550px; /* altura fixa */
  overflow: hidden;
}
@media(max-width: 768px){
  .banner_area {
  position: relative;
  width: 100%;
  height: 320px; /* altura fixa */
  overflow: hidden;
}
}

.intro-container {
  position: relative;
  width: 100%;
  
  overflow: hidden;
}

.slide {
  width: 100%;
  height: 100%;
  position: relative;
  display: none;
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

.slide.active {
  display: block;
  opacity: 1;
}

/* ======== Fundo ======== */
.carousel-background {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.carousel-background img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.bg-parallax {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.overlay {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 125%;
  bottom: 0;
  z-index: -1;
  background-color: rgba(0, 0, 0, 0.7); /* preto com 90% de opacidade */
}

/* escurecimento leve sobre a imagem (opcional) */
.overlay::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  /* tom escuro translúcido */
  z-index: 2;
}

/* ======== Conteúdo ======== */
.carousel-container {
  position: absolute;         /* muda para absoluto */
  top: 40px;
  left: 0;
  width: 100%;
  height: 100%;               /* ocupa toda a altura */
  display: flex;
  justify-content: center;    /* centraliza horizontalmente */
  align-items: center;        /* centraliza verticalmente */
  text-align: center;
  z-index: 3;                 /* acima do overlay */
}

.banner_content {
  position: relative;
  z-index: 4;
  color: #fff;
}

.banner__titulo {
  font-size: 3rem;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 15px;
  letter-spacing: 2px;
}

.banner__subtitulo {
  font-size: 1.5rem;
  font-weight: 400;
  margin-bottom: 21px;
}

.banner__botao {
  font-size: 1rem;
  font-weight: 600;
  padding: 12px 28px;
  background-color: #0082d8;
  color: #fff;
  transition: all 0.3s ease;
}

.banner__botao:hover {
  background-color: #0082d8;
  color: #fff;
}

/* ======== Responsividade ======== */

/* Tablet */
@media (max-width: 992px) {
  .intro-container {
    height: 450px;
  }

  .banner__titulo {
    font-size: 2.3rem;
  }

  .banner__subtitulo {
    font-size: 1.2rem;
  }

  .banner__botao {
    padding: 10px 24px;
    font-size: 0.95rem;
  }
}

/* Celular */
@media (max-width: 768px) {
  .intro-container {
    height: 380px;
  }

  .carousel-background img {
    object-position: center center;
  }

  .banner_content {
    padding: 10px 20px;
  }

  .banner__titulo {
    font-size: 1.8rem;
    line-height: 2rem;
  }

  .banner__subtitulo {
    font-size: 1rem;
    margin-bottom: 15px;
  }

  .banner__botao {
    padding: 8px 20px;
    font-size: 0.9rem;
  }
}

/* Celular pequeno */
@media (max-width: 480px) {
  .intro-container {
    height: 320px;
  }

  .banner__titulo {
    font-size: 1.5rem;
  }

  .banner__subtitulo {
    font-size: 0.9rem;
  }

  .banner__botao {
    padding: 7px 18px;
  }
}

.intro-container,
.carousel,
.slide,
.carousel-inner,
.carousel-item,
.carousel-background {
  height: 550px; /* garante altura fixa */
  position: relative;
}

/* Para garantir herança responsiva */
@media (max-width: 992px) {
  .intro-container,
  .carousel,
  .slide,
  .carousel-inner,
  .carousel-item,
  .carousel-background {
    height: 450px;
  }
}

@media (max-width: 768px) {
  .intro-container,
  .carousel,
  .slide,
  .carousel-inner,
  .carousel-item,
  .carousel-background {
    height: 380px;
  }
}

@media (max-width: 480px) {
  .intro-container,
  .carousel,
  .slide,
  .carousel-inner,
  .carousel-item,
  .carousel-background {
    height: 320px;
  }
}


</style>
